module.exports = "<div class=\"main-jobs-cell__title\" [ngClass]=\"{'main-jobs-cell__title--bordered' : isBorderBottom}\">\n    <i class=\"{{icon}}\" *ngIf=\"icon\"></i>\n    <img [src]=\"imgSrc\" *ngIf=\"imgSrc\">\n    <h2>{{text}}</h2>\n    <sn-label\n            *ngIf=\"galleryHeader\"\n            [text]=\"'Connected to ShootProof'\">\n    </sn-label>\n    <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/common/job-cell-header/job-cell-header.html
// module id = ./web/modern/components/common/job-cell-header/job-cell-header.html
// module chunks = 0